module.exports = __webpack_public_path__ + "static/media/warranty-3d-icon.823f8d3d.png";